import { IBasicAddress, State } from './Address';

class BillingAddress implements IBasicAddress {
  address: string;
  address2: string;
  city: string;
  state: keyof typeof State;
  zip: string;

  constructor(attributes: IBasicAddress) {
    Object.assign(this, attributes);
  }

  get firstLine(): string {
    return this.address;
  }

  get secondLine(): string {
    return this.address2;
  }

  get lastLine(): string {
    return `${this.city}, ${this.state} ${this.zip}`;
  }
}

export default BillingAddress;
